module.exports = __webpack_public_path__ + "media/login-page-bg-rzd-1366@3x.67a771f5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/login-page-bg-rzd-1366@3x.jpg
// module id = 1108
// module chunks = 62